import { render, staticRenderFns } from "./LoginLanguageSelector.vue?vue&type=template&id=5090fe3c&scoped=true"
import script from "./LoginLanguageSelector.vue?vue&type=script&lang=js"
export * from "./LoginLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./LoginLanguageSelector.vue?vue&type=style&index=0&id=5090fe3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090fe3c",
  null
  
)

export default component.exports